import { Box, Heading, Stack, Text } from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import Navbar from "../LandingPage/Navbar";

import heroBg from "@root/public/images/photos/clarifayo_montanha.jpg";

export const PricingHero = () => {
  const t = useTranslations("Pricing");

  return (
    <Stack
      gap={{ base: 8, md: 14 }}
      py={{ base: 8, md: 20 }}
      px={{
        base: 8,
        md: 20,
      }}
      justifyContent={"flex-end"}
      bgColor="brand.1000"
      h={{
        base: "90vh",
        md: "90vh",
      }}
      position="relative"
      overflow={"hidden"}
      backgroundImage={`url(${heroBg.src})`}
      backgroundSize="cover"
      backgroundPosition="center"
      backgroundAttachment="fixed"
    >
      <Box className="pricing-hero-bg"></Box>
      <Box position="absolute" top={0} left={0} w="full">
        <Navbar />
      </Box>

      <Stack
        direction={["column", "row"]}
        gap={16}
        alignItems={"flex-end"}
        w="full"
        zIndex={1}
      >
        <Box flex={1} maxW={{ base: "full", md: "50vw" }}>
          <Heading
            fontWeight={600}
            fontSize={{ base: "42px", md: "68px" }}
            mb={4}
            textAlign={{ base: "center", md: "left" }}
            color="white"
            lineHeight={"1.1"}
            letterSpacing={".1rem"}
            fontFamily={`'Marlide', sans-serif`}
          >
            <Text>{t("title")}</Text>
          </Heading>
          <Text
            fontSize={{ base: "18px", md: "22px" }}
            color="white"
            textAlign={{ base: "center", md: "left" }}
            maxW={{ base: "full", md: "500px" }}
            mb={8}
            dangerouslySetInnerHTML={{ __html: t.raw("subtitle") }}
          />
        </Box>
      </Stack>
    </Stack>
  );
};
